import { Button, Form, Input, message, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { fetchFamilyMemberType } from "./FetchFamilyMemberType";
import { EditOutlined } from "@ant-design/icons";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { create_family_member_type, update_family_member_type } from "../../endpoints/API";

const FamilyMemberType = () => {
  const baseUrl = useSelector(selectBaseUrl);
  const prodTestUrl = useSelector(selectProdTestUrl);
  const [form] = Form.useForm();
  const isUser = useSelector((state) => state.user.user);
  const [isFamilyMemberType, setIsFamilyMemberType] = useState([]);
  const [editingItem, setEditingItem] = useState(null); // State for the item being edited

  useEffect(() => {
    const fetchFamilyMemberTypeData = async () => {
      try {
        await fetchFamilyMemberType(
          setIsFamilyMemberType,
          baseUrl,
          prodTestUrl
        );
      } catch (error) {
        message.error(error?.response?.data?.error||"Failed to fetch family member types.");
      }
    };

    fetchFamilyMemberTypeData();
  }, []);

  const handleSave = async (values) => {
    const payload = {
      type: values.family_member_type,
      user_id: isUser?.id,
      type_id: editingItem?.id || "",
      id:editingItem?.id,
    };

    try {
      let response;
      if (editingItem) {
        response = await update_family_member_type(payload);
      } else {
        response = await create_family_member_type(payload);
      }

      if (response.statusText=="OK") {
        message.success(
          editingItem
            ? "Family Member Type updated successfully!"
            : "Family Member Type added successfully!"
        );
        form.resetFields();
        setEditingItem(null);
        await fetchFamilyMemberType(
          setIsFamilyMemberType,
          baseUrl,
          prodTestUrl
        );
      } else {
        message.error("Family member type already exists.");
      }
    } catch (error) {
      message.error(error?.response?.data?.error||"An error occurred. Please try again later.");
    }
  };

  const handleEdit = (record) => {
    setEditingItem(record);
    form.setFieldsValue({ family_member_type: record.name });
  };

  const column = [
    {
      title: "Family Member Type",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Edit",
      key: "edit",
      render: (text, record) => (
        <Button onClick={() => handleEdit(record)}>
          <EditOutlined />
        </Button>
      ),
    },
  ];

  return (
    <div>
      <Form form={form} onFinish={handleSave}>
        <div
          className="border flex gap-5 p-4 items-center rounded-lg shadow-md"
          style={{ padding: "16px" }}
        >
          <Form.Item
            label={
              <span className="font-semibold">
                {editingItem
                  ? "Edit Family Member Type"
                  : "Add Family Member Type"}
              </span>
            }
            name="family_member_type"
            rules={[
              { required: true, message: "Please enter family member type!" },
            ]}
            style={{ margin: "0" }}
          >
            <Input
              placeholder="Enter family member type"
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item style={{ margin: "0" }}>
            <Button type="primary" htmlType="submit">
              {editingItem ? "Update" : "Save"}
            </Button>
          </Form.Item>
        </div>
      </Form>
      <Table dataSource={isFamilyMemberType} columns={column} />
    </div>
  );
};

export default FamilyMemberType;
